// extracted by mini-css-extract-plugin
export default {"EventIcons":"EventIcons-module-ae0e576da45bc6307fcc","icon":"EventIcons-module-b7d93e5eb50b2c31d7ef"};